/**
 * Extracts plain-text tab-separated values from a rendered HTML table element.
 * Works for both <th> header cells and <td> data cells via the native `.rows`
 * and `.cells` APIs, so no markdown re-parsing is needed.
 */
export const extractTableTSV = (tableEl: HTMLTableElement): string => {
  const rows = Array.from(tableEl.rows);
  return rows
    .map(row =>
      Array.from(row.cells)
        .map(cell => cell.textContent?.trim() ?? '')
        .join('\t'),
    )
    .join('\n');
};
